module.exports = "/packs/arrow-up-a82925d90d4fc4ebd08ac6b9348e275f.svg";